import { useParams } from "react-router";
import React from "react";
import PowerBiReportContainer from "../containers/PowerBiReportContainer";
import PageContents from "../components/layouts/PageContents";
import { useDataUnlessForbidden } from "../services/api";
import IProjectHeader from "../models/IProjectHeader";
import { useSnackbar } from "notistack";

const SamplesPage: React.FC = () => {
    const { projectId } = useParams();
    const { enqueueSnackbar } = useSnackbar();

    const [title, setTitle] = React.useState("Samples");
    const [subtitle, setSubtitle] = React.useState(
        "Please wait while we retrieve the project information..."
    );

    const [project, isProjectLoading] = useDataUnlessForbidden<IProjectHeader>(
        "projects/" + projectId,
        () =>
            enqueueSnackbar(
                `We couldn't retrieve the project information. Please log out and try again.`,
                { variant: "error" }
            )
    );

    React.useEffect(() => {
        if (!isProjectLoading && project !== null) {
            setTitle("Samples");
            setSubtitle(`Samples for '${project!.name}'`);
        }
    }, [project]);

    return (
        <PageContents
            title={title}
            subtitle={subtitle}
            isForbidden={false}
            maxWidth="xl"
            variant="small"
        >
            <PowerBiReportContainer
                showNavigationTabs={true}
                showComments={false}
                projectId={parseInt(projectId!)}
                reportName="sample-receipt"
            />
        </PageContents>
    );
};

export default SamplesPage;
